/** Contas a pagar vs dívidas (empréstimos/financiamentos). */

const PAYABLE_KEYS = new Set(['account_payable', 'payable', 'other']);
const STRICT_PAYABLE_KEYS = new Set(['account_payable', 'payable']);

export function isPayablePath(pathname: string): boolean {
  const p = (pathname || '').toLowerCase();
  return (
    p.includes('contas-a-pagar') ||
    p.includes('contas/pagar') ||
    /\/(pagar|payables?)(\/|$)/.test(p)
  );
}

export function isPayableCategory(value?: string | null): boolean {
  return STRICT_PAYABLE_KEYS.has(String(value || '').toLowerCase());
}

export function isPayableTypeOrCategory(value?: string | null): boolean {
  return PAYABLE_KEYS.has(String(value || '').toLowerCase());
}

/** Fluxo de conta a pagar: path OU category/type. */
export function isPayableFlow(opts: {
  pathname?: string;
  category?: string | null;
  type?: string | null;
}): boolean {
  if (isPayablePath(opts.pathname || '')) return true;
  if (isPayableCategory(opts.category) || isPayableCategory(opts.type)) return true;
  // Backend lista other em Contas a pagar — tratar como payable no edit/detalhe.
  // Consórcio/CDC é dívida (Dívidas), não conta a pagar.
  if (isPayableTypeOrCategory(opts.category) || isPayableTypeOrCategory(opts.type)) return true;
  return false;
}

/** Contas a pagar route helpers — never use /debts/:id for payables. */
export function payableListPath(): string {
  return '/financeiro/contas?tab=pagar';
}

export function payableDetailPath(id: string | number): string {
  return `/financeiro/contas-a-pagar/${id}`;
}

export function payableEditPath(id: string | number): string {
  return `/financeiro/contas-a-pagar/${id}/editar`;
}

export function debtListPath(): string {
  return '/financeiro/dividas';
}

/** Legacy detail/edit routes still mount DebtDetail/EditDebt for true dívidas. */
export function debtDetailPath(id: string | number): string {
  return `/debts/${id}`;
}

export function debtEditPath(id: string | number): string {
  return `/debts/${id}/edit`;
}
